/**
 * @deprecated This class should not be used
 */
export class Spacing {
	[key: string]: any;
	constructor(private readonly px: number) {}

	rem(): string {
		return `${this.remValue()}rem`;
	}

	remValue(): number {
		return this.px / 16;
	}

	toString(): string {
		return this.rem();
	}
}
